module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"count":"件"},"zh_hk":{"count":"件"},"en":{"count":"pieces"},"ja":{"count":"点"}}')
  delete Component.options._Ctor
}
